import {
  updateResourceState,
  createResourceReducer,
  RESOURCE
} from 'react-structure-admin';

import {
  CHECKINGACCOUNT,
  CHECKINGACCOUNT_REFRESH_RESOURCE,
  CHECKINGACCOUNT_FETCH_BALANCES,
  CHECKINGACCOUNT_FETCH_BALANCES_FINISHED
} from './checkingAccountActions';

const checkingAccountReducer = createResourceReducer(CHECKINGACCOUNT, [], {
  [CHECKINGACCOUNT_REFRESH_RESOURCE](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loaded: false
    }));
  },

  [CHECKINGACCOUNT_FETCH_BALANCES](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      loading: true
    }));
  },

  [CHECKINGACCOUNT_FETCH_BALANCES_FINISHED](state, action) {
    return updateResourceState(state, action, RESOURCE, () => ({
      balances: action.payload.data.result,
      loading: false
    }));
  }
});

export default checkingAccountReducer;
